/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
// eslint-disable-next-line jsx-a11y/click-events-have-key-events

import React from 'react';
import {
    bool, object, arrayOf, number, shape, string, array,
} from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import withStyles from '@material-ui/core/styles/withStyles';
import Grid from '@material-ui/core/Grid';
import KeyboardArrowUp from '@material-ui/icons/KeyboardArrowUp';
import Media from 'react-media';

import { getBrand } from '../../../../../state/ducks/App/ducks/Brand/Brand-Selectors';
// import EventDispatcher from '../../state/reducers/EventDispatcher';
import BackButton from '../../common/BackButton';
import DeliveryHours from './DeliveryHours';
import OrderList from './OrderList';
import TrackOrderByZipCode from './TrackOrderByZipCode';
import Loading from '../../common/Loading';
import CUSTOM_BREAKPOINTS from '../../style/customBreakpoints';
import { TrackOrderStyle } from '../../style/TrackOrderStyle';
import getSiteConfig from '../../utils/getSiteConfig';
import configENV from '../../config';
import DesktopOrerHeader from '../DesktopOrdersList/DesktopOrderHeader';
import DesktopTrackOrder  from './DesktopTrackOrder/DesktopTrackOrder';
import AccountLeftMenu from '../../common/Desktop/AccountLeftMenu';
import GraphqlSeoHeadTags from '../../../../components/GraphqlComponents/GraphqlCommonComponents/GraphqlSeoHeadTags/GraphqlSeoHeadTags';
import OrderTrackingOutage from '../OrderTrackingOutage/OrderTrackingOutage';

const { PERSIST_KEY } = configENV;

const styles = ({ typography, palette }) => TrackOrderStyle(typography, palette);

class TrackOrders extends React.Component {
    // eslint-disable-next-line camelcase
    // UNSAFE_componentWillMount = () => {
    //     const { fetchOrdersByEmail, userProfile: { isAuthenticated } } = this.props;
    //     if (isAuthenticated && fetchOrdersByEmail) fetchOrdersByEmail();
    // };

    componentDidMount = () => {
        if (typeof window !== 'undefined') {
            window.scrollTo(0, 0);
        }
    };

    handleBackToTopClicked = () => {
        if (typeof window !== 'undefined') {
            window.scrollTo(0, 0);
        }
    };

    render() {
        const {
            classes,
            userProfile,
            featureFlags,
            userProfile: { isAuthenticated },
            isFetchingModal,
            orderList,
            brand,
            ROSSOrders,
        } = this.props;
        const breakpointExpr =  `(max-width: ${(CUSTOM_BREAKPOINTS.tabLandscape)}px)`;
        if (!orderList && !ROSSOrders) return null;
        if ((isFetchingModal) && isAuthenticated) {
            return <Loading pageTitle="Orders" />;
        }
        const seo = {
            page_title: 'My Account',
            meta_description: '',
        };

        if (featureFlags['is-atlas-maintenance-alert-enabled']) {
            return <OrderTrackingOutage />;
        }

        if (['PLA', '08F', 'CAN'].includes(brand?.code)) {
            return <DesktopTrackOrder />;
        }

        return (
            <>
                <GraphqlSeoHeadTags seoData={seo} alternativeLang="true" />
                {featureFlags['is-atlas-maintenance-alert-enabled'] && (
                    <OrderTrackingOutage />
                )}
                {isAuthenticated ? (
                    <div className={classes.TrackOrderStyle}>
                        <Media query={breakpointExpr}>
                            {(matches) => (
                                matches ? (
                                    <div>
                                        <h1>
                                            <BackButton url="/account" />
                                            Order Tracking
                                        </h1>
                                        <DeliveryHours />
                                        <OrderList orders={orderList} />
                                        {orderList.length > 2 ? (
                                            <span className="back-to-top-wrapper">
                                                <a
                                                    className="back-to-top-link"
                                                    onClick={() => this.handleBackToTopClicked()}
                                                >
                                                    Back to Top <KeyboardArrowUp />
                                                </a>
                                            </span>
                                        ) : (
                                            ''
                                        )}
                                        {orderList.length === 0 ? (
                                            <div>
                                                Can&apos;t find your order? Please call{' '}
                                                {getSiteConfig('phoneNumber')}
                                            </div>
                                        ) : (
                                            ''
                                        )}
                                    </div>
                                ) : (
                                    <Grid className="container" container>
                                        <AccountLeftMenu userProfile={userProfile} featureFlags={featureFlags} customClass="trackOrder" />
                                        <Grid item xs={10}>
                                            <DesktopOrerHeader />
                                            <OrderList orders={orderList} />
                                            {orderList.length === 0 ? (
                                                <div className="desktop-no-orders">
                                                    Can&apos;t find your order? Please call{' '}
                                                    {getSiteConfig('phoneNumber')}
                                                </div>
                                            ) : (
                                                ''
                                            )}
                                        </Grid>
                                    </Grid>
                                )
                            )}
                        </Media>
                    </div>
                ) : (
                    <Media query={breakpointExpr}>
                        {(matches) => (
                            matches ? (
                                <>
                                    <h1>Order Tracking</h1>
                                    <TrackOrderByZipCode />
                                </>
                            ) : (
                                <DesktopTrackOrder />
                            )
                        )}
                    </Media>
                )}
            </>
        );
    }
}

TrackOrders.defaultProps = {
    // fetchOrdersByEmail: () => {},
    orderList: [],
    featureFlags: {},
    ROSSOrders: [],
};

TrackOrders.propTypes = {
    classes: object.isRequired,
    isFetchingModal: bool.isRequired,
    // fetchOrdersByEmail: func,
    orderList: arrayOf(
        shape({
            orderNumber: string,
            intOrderNumber: string,
            orderPlaceddate: string,
            customerFirstName: string,
            customerLastName: string,
            modifyOrder: string,
            parentOrderNumber: string,
            uuid: string,
            items: arrayOf(
                shape({
                    brandId: string,
                    productSku: string,
                    productName: string,
                    recpFirstName: string,
                    recpLastName: string,
                    shipDate: string,
                    paymentStatus: string,
                    estimatedDeliveryDate: string,
                    trackingNumber: string,
                    itemType: string,
                    sfItemType: string,
                    addonType: string,
                    parentLineNumber: string,
                    childLineNumber: string,
                    flexDate: string,
                    flexMessage: string,
                    flexGuaranteedFlag: string,
                    prdImgCtg: string,
                    prdImgTmn: string,
                    arrivalStartDate: string,
                    arrivalEndDate: string,
                    carrier: string,
                    seoUrl: string,
                    subscriptionType: string,
                    interval: string,
                    duration: string,
                }),
            ),
        }),
    ),
    userProfile: shape({
        accessToken: string,
        idToken: string,
        ContactId: string,
        userType: string,
        userRole: string,
        email: string,
        aud: string,
        iat: number,
        exp: number,
        sub: string,
        firstName: string,
        lastName: string,
        loginsCount: number,
        isAuthenticated: bool,
        isGuestAccount: bool,
    }).isRequired,
    ROSSOrders: arrayOf(
        shape({
            brandId: string,
            modifiedDateTime: string,
            orderNumber: string,
            modifyOrder: string,
            uuid: string,
            status: string,
            orders: arrayOf(
                shape({
                    carrier: string,
                    history: array,
                    brandId: string,
                    type: string,
                    deliveryDate: string,
                    modifiedDateTime: string,
                    status: string,
                    statusDescription: string,
                    trackingNumber: string,
                    warningMessage: string,
                    items: arrayOf(
                        shape({
                            duration: string,
                            interval: string,
                            itemType: string,
                            prdImgCtg: string,
                            prdImgTmn: string,
                            productName: string,
                            productSku: string,
                            seoUrl: string,
                            subscriptionType: string,
                        }),
                    ),
                }),
            ),
        }),
    ),
    featureFlags: object,
    brand: object.isRequired,
};

const mapStateToProps = (state) => {
    /* istanbul ignore next */
    const newState = state[PERSIST_KEY] ? state[PERSIST_KEY] : state;
    return {
        isFetchingModal: newState.isFetchingModal,
        toggleState: newState.toggleState,
        orderList: newState.orderList,
        ROSSOrders: newState.ROSSOrders,
        brand: getBrand(state),
    };
};

// const mapDispatchToProps = (dispatch) => ({
//     fetchOrdersByEmail: () => dispatch(EventDispatcher.fetchOrdersByEmail()),
// });

export default connect(
    mapStateToProps,
    null,
)(withRouter(withStyles(styles, { withTheme: true })(TrackOrders)));
